// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_ju-0";
export var optionCard = "_ju-1";